/* RESPONSIBLE TEAM: team-fin-voice */
import FinVoiceSerializer from '../step';

export default FinVoiceSerializer;
